<template>
  <div>
    <div class="corner forced-flex-wrapper" :style="pageStyle">
      <div class="row">
        <div class="col-md-11">
          <b-button
            v-if="isManagementMode"
            variant="secondary"
            class="col-2 float-right"
            v-b-toggle.page-style-modal
            >Display Settings</b-button
          >
        </div>
      </div>
      <b-container class="bv-example-row">
        <hero-skeleton v-if="!publishing || isLoading" />
        <template v-else>
          <div class="row">
            <div class="col-md-11">
              <corner-display
                  style="margin-top: 75px"
                ref="corner-display"
                :is-management-mode="isManagementMode"
                :publishing="publishing"
                :corner-listing="cornerListing"
                :corner-title="cornerTitle"
                :resource-path="resourcePath"
                :resource-item-path="resourceItemPath"
                @refresh-publishing="handleRefreshPublishing"
              />
            </div>
          </div>
        </template>
      </b-container>
    </div>
    <page-style
      @modalId="pageStyleModalId"
      :pageStyle="pageStyle"
      :publishing="publishing"
      @refresh-publishing="handleRefreshPublishing"
    ></page-style>
  </div>
</template>

<script>
import HeroSkeleton from "./hero/skeleton";
import { mapGetters } from "vuex";
import CornerDisplay from "./cornerDisplay";
import pageStyle from "./pageStyle";

export default {
  name: "Corner",
  components: {
    HeroSkeleton,
    CornerDisplay,
    pageStyle
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    cornerListing: {
      type: Object,
      required: false,
      default: () => {}
    },
    cornerTitle: {
      type: String,
      required: false,
      default: null
    },
    resourcePath: {
      type: String,
      required: false,
      default: null
    }, //live version of landing on pages
    resourceItemPath: {
      type: String,
      required: false,
      default: null
    } //live version of landing on pages
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      listPublishings: "user/listPublishings"
    })
  },
  watch: {
    publishing: {
      immediate: true,
      handler(val, oldValue) {
        console.log("watcher => ", val);
        if (val.pageStyle && val.pageStyle.style) {
          this.pageStyle = val.pageStyle.style;
        } else {
          this.pageStyle = {
            backgroundColor: "#ffc728",
            color: "#343a40",
            fontSize: "1rem",
            fontWeight: 400,
            background: ""
          };
        }
      },
      deep: true
    }
  },
  methods: {
    handleRefreshPublishing() {
      //console.log('refreshing publishing - corner');
      this.$emit("refresh-publishing");
    },
    handleBreakdownCorner() {
      //Remove Resource Data
      this.$refs["corner-display"].handleResourceConceal();
    },
    handlePageStyleClick() {
      this.$bvModal.show(this.pageStyleModalId);
    }
  },
  data() {
    return {
      pageStyleModalId: "page-style-modal",
      pageStyle: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.forced-flex-wrapper {
  display: flex;
  min-height: 25vh;
  flex-direction: column;
  justify-content: space-between;
}

.corner {
  background-color: #ffc728;
  padding-top: 15px;
  padding-bottom: 0px;

  .float-right {
    float: right;
  }
}
</style>
